export default "__VITE_ASSET__GC5SyFmU__"